import { render, staticRenderFns } from "./adrefule.vue?vue&type=template&id=4b605310&scoped=true"
import script from "./adrefule.vue?vue&type=script&lang=js"
export * from "./adrefule.vue?vue&type=script&lang=js"
import style0 from "./adrefule.vue?vue&type=style&index=0&id=4b605310&prod&lang=css"
import style1 from "./adrefule.vue?vue&type=style&index=1&id=4b605310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b605310",
  null
  
)

export default component.exports